export const truncateString = (text: string, maxlength: number) => {
  return text.length > maxlength ? text.slice(0, maxlength - 1) + '…' : text;
};
